import { isValidEmail, isValidMobile } from '@domain-group/javascript-utils'

const state = {
  contact_email: '',
  contact_name: '',
  contact_number: '',
  contact_type: '',
  id: null,
}

export const requiredFields = [
  { key: 'contact_email', validation: isValidEmail, invalidMessage: 'Invalid Email format' },
  { key: 'contact_name' },
  { key: 'contact_number', validation: isValidMobile, invalidMessage: 'Invalid Mobile format' },
  { key: 'contact_type' },
]

export default state
